// @ts-nocheck
import { usePayPeriodRepository } from '../repositories';
// TODO: useCreatePayPeriod and useTransitionPayPeriod need dedicated mutations
// not covered by repository CRUD. Remove compat imports once the repository
// supports custom mutations.
import { useCompatMutation } from './useApolloCompat';
import {
  PAY_PERIODS_QUERY,
  CREATE_PAY_PERIOD_MUTATION,
  TRANSITION_PAY_PERIOD_MUTATION,
} from '../graphql/operations';

export function usePayPeriods(variables?: { page?: number; perPage?: number }) {
  const repo = usePayPeriodRepository();
  return repo.useList(variables);
}

// TODO: Migrate to repository pattern once PayPeriod repository supports create.
export function useCreatePayPeriod() {
  return useCompatMutation(CREATE_PAY_PERIOD_MUTATION, {
    refetchQueries: [{ query: PAY_PERIODS_QUERY }],
  });
}

// TODO: Migrate to repository pattern once custom mutations are supported.
// transitionPayPeriod is a specialized state-machine action, not a standard CRUD update.
export function useTransitionPayPeriod() {
  return useCompatMutation(TRANSITION_PAY_PERIOD_MUTATION, {
    refetchQueries: [{ query: PAY_PERIODS_QUERY }],
  });
}
